import './IconButton.css';
export default {
    "white": "#fff",
    "neutral-100": "#f8f7fa",
    "neutral-200": "#efedf2",
    "neutral-300": "#dddae3",
    "neutral-400": "#c1bdc7",
    "neutral-500": "#918d99",
    "neutral-600": "#716b7a",
    "neutral-700": "#585163",
    "neutral-800": "#3a3247",
    "neutral-900": "#261b36",
    "neutral-1000": "#13002d",
    "root": "IconButton_root__18146",
    "default": "IconButton_default__18146",
    "onDarkBackground": "IconButton_onDarkBackground__18146",
    "onLightBackground": "IconButton_onLightBackground__18146",
    "outline": "IconButton_outline__18146",
    "disabled": "IconButton_disabled__18146"
};
